module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "panoramaContainer"
    }
  }, [_c('div', {
    staticClass: "container container-margin-top is-fluid content-padding",
    attrs: {
      "id": "view-panorama"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    attrs: {
      "id": "panorama-cube-holder"
    }
  }, [_c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-one-third-tablet is-2-desktop"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Frente")]), _vm._v(" "), _c('figure', {
    staticClass: "image is-square"
  }, [(!_vm.newImages[0] && _vm.panoramaInfo.cubes[0]) ? _c('figure', {
    staticClass: "panorama-image fake-dropzone",
    on: {
      "click": function($event) {
        _vm.showDropzone(0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl(0)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dz-remove"
  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (_vm.newImages[0] || !_vm.panoramaInfo.cubes[0]) ? _c('p', {
    staticClass: "control dropzone-holder"
  }, [_c('dropzone', {
    staticClass: "marginless-dropzone dz-dom dz-element",
    attrs: {
      "id": "panoramaPosition0Dz",
      "url": _vm.dropzoneUploadUrl + '?position=0',
      "acceptedFileTypes": "image/*"
    },
    on: {
      "vdropzone-success": _vm.successUploadImage,
      "vdropzone-removedfile": function($event) {
        _vm.removeImage(0)
      }
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third-tablet is-2-desktop"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Esquerda")]), _vm._v(" "), _c('figure', {
    staticClass: "image is-square"
  }, [(!_vm.newImages[1] && _vm.panoramaInfo.cubes[1]) ? _c('figure', {
    staticClass: "panorama-image fake-dropzone",
    on: {
      "click": function($event) {
        _vm.showDropzone(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl(1)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dz-remove"
  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (_vm.newImages[1] || !_vm.panoramaInfo.cubes[1]) ? _c('p', {
    staticClass: "control dropzone-holder"
  }, [_c('dropzone', {
    staticClass: "marginless-dropzone dz-dom dz-element",
    attrs: {
      "id": "panoramaPosition1Dz",
      "url": _vm.dropzoneUploadUrl + '?position=1',
      "acceptedFileTypes": "image/*"
    },
    on: {
      "vdropzone-success": _vm.successUploadImage,
      "vdropzone-removedfile": function($event) {
        _vm.removeImage(1)
      }
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third-tablet is-2-desktop"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Trás")]), _vm._v(" "), _c('figure', {
    staticClass: "image is-square"
  }, [(!_vm.newImages[2] && _vm.panoramaInfo.cubes[2]) ? _c('figure', {
    staticClass: "panorama-image fake-dropzone",
    on: {
      "click": function($event) {
        _vm.showDropzone(2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl(2)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dz-remove"
  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (_vm.newImages[2] || !_vm.panoramaInfo.cubes[2]) ? _c('p', {
    staticClass: "control dropzone-holder"
  }, [_c('dropzone', {
    staticClass: "marginless-dropzone dz-dom dz-element",
    attrs: {
      "id": "panoramaPosition2Dz",
      "url": _vm.dropzoneUploadUrl + '?position=2',
      "acceptedFileTypes": "image/*"
    },
    on: {
      "vdropzone-success": _vm.successUploadImage,
      "vdropzone-removedfile": function($event) {
        _vm.removeImage(2)
      }
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third-tablet is-2-desktop"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Direita")]), _vm._v(" "), _c('figure', {
    staticClass: "image is-square"
  }, [(!_vm.newImages[3] && _vm.panoramaInfo.cubes[3]) ? _c('figure', {
    staticClass: "panorama-image fake-dropzone",
    on: {
      "click": function($event) {
        _vm.showDropzone(3)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl(3)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dz-remove"
  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (_vm.newImages[3] || !_vm.panoramaInfo.cubes[3]) ? _c('p', {
    staticClass: "control dropzone-holder"
  }, [_c('dropzone', {
    staticClass: "marginless-dropzone dz-dom dz-element",
    attrs: {
      "id": "panoramaPosition3Dz",
      "url": _vm.dropzoneUploadUrl + '?position=3',
      "acceptedFileTypes": "image/*"
    },
    on: {
      "vdropzone-success": _vm.successUploadImage,
      "vdropzone-removedfile": function($event) {
        _vm.removeImage(3)
      }
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third-tablet is-2-desktop"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Topo")]), _vm._v(" "), _c('figure', {
    staticClass: "image is-square"
  }, [(!_vm.newImages[4] && _vm.panoramaInfo.cubes[4]) ? _c('figure', {
    staticClass: "panorama-image fake-dropzone",
    on: {
      "click": function($event) {
        _vm.showDropzone(4)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl(4)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dz-remove"
  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (_vm.newImages[4] || !_vm.panoramaInfo.cubes[4]) ? _c('p', {
    staticClass: "control dropzone-holder"
  }, [_c('dropzone', {
    staticClass: "marginless-dropzone dz-dom dz-element",
    attrs: {
      "id": "panoramaPosition4Dz",
      "url": _vm.dropzoneUploadUrl + '?position=4',
      "acceptedFileTypes": "image/*"
    },
    on: {
      "vdropzone-success": _vm.successUploadImage,
      "vdropzone-removedfile": function($event) {
        _vm.removeImage(4)
      }
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third-tablet is-2-desktop"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Fundo")]), _vm._v(" "), _c('figure', {
    staticClass: "image is-square"
  }, [(!_vm.newImages[5] && _vm.panoramaInfo.cubes[5]) ? _c('figure', {
    staticClass: "panorama-image fake-dropzone",
    on: {
      "click": function($event) {
        _vm.showDropzone(5)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl(5)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dz-remove"
  }, [_vm._v("Remover")])]) : _vm._e(), _vm._v(" "), (_vm.newImages[5] || !_vm.panoramaInfo.cubes[5]) ? _c('p', {
    staticClass: "control dropzone-holder"
  }, [_c('dropzone', {
    staticClass: "marginless-dropzone dz-dom dz-element",
    attrs: {
      "id": "panoramaPosition5Dz",
      "url": _vm.dropzoneUploadUrl + '?position=5',
      "acceptedFileTypes": "image/*"
    },
    on: {
      "vdropzone-success": _vm.successUploadImage,
      "vdropzone-removedfile": function($event) {
        _vm.removeImage(5)
      }
    }
  })], 1) : _vm._e()])])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns pantitltfov is-mobile"
  }, [_c('div', {
    staticClass: "column is-fifth"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pan")]), _vm._v(": " + _vm._s(_vm.panoramaInfo.pan.toFixed(4)))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-fifth"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tilt")]), _vm._v(": " + _vm._s(_vm.panoramaInfo.tilt.toFixed(4)))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-fifth"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fov")]), _vm._v(": " + _vm._s(_vm.panoramaInfo.fov.toFixed(4)))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-fifth"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-fifth"
  })]), _vm._v(" "), _c('div', {
    staticClass: "columns panoramaButtons"
  }, [_c('div', {
    staticClass: "column is-third"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": _vm.resetPanoramaView
    }
  }, [_vm._v("Voltar à vista inicial")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-third"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": _vm.setNewStart
    }
  }, [_vm._v("Definir nova vista inicial")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-third"
  }, [_c('a', {
    staticClass: "button is-success",
    on: {
      "click": _vm.createHotspot
    }
  }, [_vm._v("Criar Hotspot")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.panoramaPoints), function(point) {
    return _c('tr', {
      attrs: {
        "id": 'point_' + point.pointId
      }
    }, [_c('td', [_vm._v(_vm._s(point.languages[0].name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(point.pan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(point.tilt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(point.fov))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-success",
      on: {
        "click": function($event) {
          _vm.setView(point.pointId)
        }
      }
    }, [_vm._v("Mostrar no panorama")])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button",
      on: {
        "click": function($event) {
          _vm.updateHotspot(point.pointId)
        }
      }
    }, [_vm._v("Editar texto")])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button",
      on: {
        "click": function($event) {
          _vm.setNewView(point.pointId)
        }
      }
    }, [_vm._v("Definir novo enquadramento")])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "button is-danger",
      on: {
        "click": function($event) {
          _vm.deleteHotspot(point.pointId)
        }
      }
    }, [_vm._v("Apagar")])])])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('figure', {
    staticClass: "image is-16by9"
  }, [_c('div', {
    attrs: {
      "id": "panoramaViewer"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "crossairHolder"
    }
  }, [_c('div', {
    attrs: {
      "id": "crossairInner"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Pan")]), _vm._v(" "), _c('th', [_vm._v("Tilt")]), _vm._v(" "), _c('th', [_vm._v("Fov")]), _vm._v(" "), _c('th', [_vm._v("Mostrar")]), _vm._v(" "), _c('th', [_vm._v("Editar Texto")]), _vm._v(" "), _c('th', [_vm._v("Enquadramento")]), _vm._v(" "), _c('th', [_vm._v("Apagar")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-093ee03c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panorama/PanoramaContainer.vue
// module id = 302
// module chunks = 1